var map = {
	"./B3车库入口.mp4": 5279,
	"./D2 大堂4.mp4": 7261,
	"./D2天台西.mp4": 6261,
	"./D2负一楼大堂后门.mp4": 5453,
	"./D2负二楼大堂后门.mp4": 8138,
	"./二期负三D区05通道.mp4": 4970,
	"./二期负三D区07停车位026.mp4": 2268,
	"./二期负二D区11通道.mp4": 3923,
	"./儿童活动区球机.mp4": 7543,
	"./幼儿园后休闲通道.mp4": 6494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 411;